import Swiper from 'swiper/dist/js/swiper.min.js';

jQuery(document).ready(function($) {
  if (!$('.latest-news-sharp').length) {
    return;
  }

  if ($(window).width() < 1023) {
    new Swiper('.latest-news-sharp-row', {
      slidesPerView: 1,
      navigation: {
        prevEl: '.latest-news-sharp-prev-button',
        nextEl: '.latest-news-sharp-next-button',
      },
      effect: 'coverflow',
      centeredSlides: true,
      loop: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 80,
        depth: 200,
        modifier: 1,
        slideShadows : false,
      },
    });
  } else {
    new Swiper('.latest-news-sharp-row', {
      slidesPerView: 3,
      loop: true,
      navigation: {
        prevEl: '.latest-news-sharp-prev-button',
        nextEl: '.latest-news-sharp-next-button',
      },
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/blocks/latest-news-sharp.js